export default __webpack_public_path__ + "static/media/ASSETSDISCOV_Dashboard.6493a542.svg";